import '/assets/styles/sections/web-page-header.scss';
import classNames from 'classnames';

// Partials
import Link from '@wearetla/tla-essentials-tools/partials/link';
import Icon from '@wearetla/tla-essentials-tools/partials/icon';
import Placeholder from '/views/partials/placeholder';
import Img from '@wearetla/tla-essentials-tools/partials/img';

// Static Assets
import image_logo from '/assets/images/logo-white.svg';

// Context
import { useModals } from '@wearetla/tla-essentials-tools/utilities/modals';
import { useTranslation } from '/utilities/i18n';
import { getLanguage } from '/data/languages';

const WebPageHeader = ({ title, backLink, className }) => {
	const { openModal } = useModals();
	const { language } = useTranslation();
	return (
		<section className={classNames('section', 'web-menu-header', className)}>
			<div className="header-top">
				<div className="wrapper top-wrap">
					<Img src={image_logo} className="header-logo" />

					<button
						type="button"
						className="header-languagebtn"
						onClick={() => openModal('languages')}
					>
						{getLanguage(language)?.flag} {language.toUpperCase()}
					</button>
				</div>
			</div>
			<div className="header-bottom">
				<div className="wrapper bottom-wrap">
					{backLink !== false && (
						<>
							{backLink ? (
								<Link className="bottom-backbtn" {...backLink}>
									<Icon name="angle-left" />
								</Link>
							) : (
								<span className="bottom-backbtn disabled">
									<Icon name="angle-left" />
								</span>
							)}
						</>
					)}
					{title ? (
						<h1 className="bottom-title">{title}</h1>
					) : (
						<Placeholder className="bottom-title" />
					)}
				</div>
			</div>
		</section>
	);
};

export default WebPageHeader;
